import React from 'react';

/**
 * AalimLogo Component - Uses the official uploaded logo
 * With tighter spacing between logo and text
 */
export const AalimLogo = ({ size = 40, className = '', showText = true, textSize = 'text-xl' }) => {
    return (
        <div className={`flex items-center gap-1.5 ${className}`}>
            <img 
                src="/aalim-logo.png" 
                alt="Aalim.ai Logo" 
                className="object-contain"
                style={{ width: size, height: size }}
            />
            
            {showText && (
                <span className={`font-heading ${textSize} font-semibold text-foreground`}>
                    aalim<span className="text-secondary">.ai</span>
                </span>
            )}
        </div>
    );
};

/**
 * Compact logo for navbar and small spaces - uses original PNG
 * Supports both size prop (fixed) and className (responsive)
 */
export const AalimLogoCompact = ({ size, className = '' }) => {
    // If className contains width/height classes, use those instead of fixed size
    const hasResponsiveClasses = className.includes('w-') || className.includes('h-');
    
    return (
        <img 
            src="/aalim-logo.png" 
            alt="Aalim.ai" 
            className={`object-contain ${className}`}
            style={!hasResponsiveClasses && size ? { width: size, height: size } : undefined}
        />
    );
};

/**
 * Khatim Star Logo - main logo for hero sections
 * Supports responsive sizing via className or fixed size prop
 */
export const KhatimStarLogo = ({ size, className = '' }) => {
    // If className contains width/height classes, use those instead of fixed size
    const hasResponsiveClasses = className.includes('w-') || className.includes('h-');
    
    return (
        <img 
            src="/aalim-logo.png" 
            alt="Aalim.ai" 
            className={`object-contain ${className}`}
            style={!hasResponsiveClasses && size ? { width: size, height: size } : undefined}
        />
    );
};

export default AalimLogo;
